import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Drawer, Typography } from '@mui/material';
import Scrollbar from 'components/Scrollbar';
import MobileHidden from 'components/MobileHidden';
import menus from 'common/constants/menus';
import SideNav from 'components/SideNav';

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: DRAWER_WIDTH,
  },
  position: 'fixed',
  top: 64,
  zIndex: 1,
  height: '100vh',
  borderWidth: '0px 1px 1px 0px',
  borderStyle: 'solid',
  borderColor: '#DEE2E6',
  background: '#fff',
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200],
}));

interface IProps {
  isOpenSidebar: boolean;
  onCloseSidebar: () => void;
}

export function Sidebar({ isOpenSidebar, onCloseSidebar }: IProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <div style={{ width: DRAWER_WIDTH }} />
      <RootStyle>
        <SideNav navConfig={menus} />
      </RootStyle>
    </>
  );
}
